import { createStyles, makeStyles } from '@material-ui/core';

const styles = () => createStyles({
  statusList: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    flexWrap: 'wrap',
  },
  showMoreButton: {
    alignSelf: 'flex-start',
    color: '#DB5C0E',
    fontSize: 14,
    fontWeight: 700,
    minWidth: 'auto',
    padding: '2px 6px',
    textTransform: 'none',
  },
  dialogContent: {
    maxHeight: '60vh',
    padding: 0,
  },
  deviceRow: {
    alignItems: 'center',
    borderBottom: '1px solid #ECEFF1',
    display: 'flex',
    padding: '12px 24px',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  deviceIconWrap: {
    alignItems: 'center',
    borderRadius: '50%',
    display: 'inline-flex',
    flexShrink: 0,
    height: 36,
    justifyContent: 'center',
    marginRight: 12,
    width: 36,
  },
  deviceIcon: {
    fontSize: 20,
  },
  deviceInfo: {
    minWidth: 0,
  },
  deviceName: {
    color: '#263238',
    fontSize: 14,
    fontWeight: 600,
    overflowWrap: 'break-word',
  },
  deviceStatus: {
    fontSize: 12,
    fontWeight: 600,
    marginTop: 2,
    overflowWrap: 'break-word',
  },
});

export default makeStyles(styles);
